export enum VisitorType {
	Contractor = 10,
	Visitor = 20
}